import React from 'react'

const Jva_ap = () => {
    return (
        <div className='container'>
            <h1>Program to print Arithmetic Progression series</h1>
            <p>Given first term (a), common difference (d) and a integer n of the Arithmetic Progression series, the task is to print the series. </p>
            <p><strong>Examples : </strong></p>
            <pre className='output'>Input : a = 5, d = 2, n = 10 <br />
Output : 5 7 9 11 13 15 17 19 21 23</pre>
            <p><strong>Approach :</strong>&nbsp;<br />&nbsp;</p>
            <blockquote className='output'><p>We know the Arithmetic Progression series is like = 2, 5, 8, 11, 14 …. …&nbsp;<br />
In this series 2 is the stating term of the series .&nbsp;<br />
Common difference = 5 – 2 = 3 (Difference common in the series).&nbsp;<br />
so we can write the series as :&nbsp;<br />
t1 = a1&nbsp;<br />
t2 = a1 + (2-1) * d&nbsp;<br />
t3 = a1 + (3-1) * d&nbsp;<br />
.&nbsp;<br />
.&nbsp;<br />
.&nbsp;<br />
tn = a1 + (n-1) * d&nbsp;<br />
&nbsp;</p></blockquote>
            <div class="containers">
                <div class="line number1 index0 alt2"><code class="comment">// Java Program to print an arithmetic</code></div>
                <div class="line number2 index1 alt1"><code class="comment">// progression series</code></div>
                <div class="line number3 index2 alt2"><code class="keywords">class</code> <code class="plain">NooB</code></div>
                <div class="line number4 index3 alt1"><code class="plain">&#123;</code></div>
                <div class="line number5 index4 alt2"><code class="keywords">static</code> <code class="keywords">void</code> <code
                    class="plain">printAP(</code><code class="keywords">int</code> <code class="plain">a, </code><code
                        class="keywords">int</code> <code class="plain">d, </code><code class="keywords">int</code> <code
                            class="plain">n)</code></div>
                <div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
                <div class="line number7 index6 alt2">&nbsp;</div>
                <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="comment">// Printing AP by simply adding d</code></div>
                <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="comment">// to previous term.</code></div>
                <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keywords">int</code> <code class="plain">curr_term;</code></div>
                <div class="line number11 index10 alt2"><code class="plain">curr_term=a;</code></div>
                <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="keywords">for</code> <code class="plain">(</code><code class="keywords">int</code> <code
                        class="plain">i = </code><code class="value">1</code><code class="plain">; i &lt;= n; i++)</code></div>
                <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">&#123; System.out.print(curr_term + </code><code class="string">" "</code><code
                        class="plain">);</code></div>
                <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">curr_term =curr_term + d;</code></div>
                <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
                <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                    class="plain">&#125;</code></div>
                <div class="line number17 index16 alt2"><code class="plain">&#125;</code></div>
                <div class="line number18 index17 alt1">&nbsp;</div>
                <div class="line number19 index18 alt2"><code class="comment"></code></div>
                <div class="line number20 index19 alt1"><code class="keywords">public</code> <code class="keywords">static</code> <code
                    class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                <div class="line number21 index20 alt2"><code class="plain">&#123;</code></div>
                <div class="line number22 index21 alt1"><code class="comment">// starting number</code></div>
                <div class="line number23 index22 alt2"><code class="keywords">int</code> <code class="plain">a = </code><code
                    class="value">2</code><code class="plain">;</code></div>
                <div class="line number24 index23 alt1">&nbsp;</div>
                <div class="line number25 index24 alt2"><code class="comment">// Common difference</code></div>
                <div class="line number26 index25 alt1"><code class="keywords">int</code> <code class="plain">d = </code><code
                    class="value">1</code><code class="plain">;</code></div>
                <div class="line number27 index26 alt2">&nbsp;</div>
                <div class="line number28 index27 alt1"><code class="comment">// N th term to be find</code></div>
                <div class="line number29 index28 alt2"><code class="keywords">int</code> <code class="plain">n = </code><code
                    class="value">5</code><code class="plain">;</code></div>
                <div class="line number30 index29 alt1">&nbsp;</div>
                <div class="line number31 index30 alt2"><code class="plain">printAP(a, d, n);</code></div>
                <div class="line number32 index31 alt1"><code class="plain">&#125;</code></div>
                <div class="line number33 index32 alt2"><code class="plain">&#125;</code></div>
            </div>
            <div class="output"><strong>Output:</strong>&nbsp; <br/>
   <pre>2 3 4 5 6</pre> <br/>
   <p>&nbsp;</p>
</div>

        </div>
    )
}

export default Jva_ap
